import { render, staticRenderFns } from "./EntitySignMint.vue?vue&type=template&id=634aff80&"
import script from "./EntitySignMint.vue?vue&type=script&lang=js&"
export * from "./EntitySignMint.vue?vue&type=script&lang=js&"
import style0 from "./EntitySignMint.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports